/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateProviderDto,
  GetProvidersParams,
  ProviderDto,
  SsoLoginParams,
  UpdateProviderDto
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetProvidersUrl = (params?: GetProvidersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Sso/GetProviders?${stringifiedParams}` : `/api/Sso/GetProviders`
}

export const getProviders = async (params?: GetProvidersParams, options?: Parameters<typeof customInstance>[1]): Promise<ProviderDto[]> => {

  return customInstance<ProviderDto[]>(getGetProvidersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProvidersQueryKey = (params?: GetProvidersParams,) => {
    return [
    `/api/Sso/GetProviders`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProvidersQueryOptions = <TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(params?: GetProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProviders>>> = ({ signal }) => getProviders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof getProviders>>>
export type GetProvidersQueryError = ErrorType<unknown>


export function useGetProviders<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProvidersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviders>>,
          TError,
          Awaited<ReturnType<typeof getProviders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProviders<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
 params?: GetProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviders>>,
          TError,
          Awaited<ReturnType<typeof getProviders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProviders<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
 params?: GetProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProviders<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
 params?: GetProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProvidersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(params?: GetProvidersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProviders>>> = ({ signal }) => getProviders(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProvidersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProviders>>>
export type GetProvidersSuspenseQueryError = ErrorType<unknown>


export function useGetProvidersSuspense<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProvidersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersSuspense<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
 params?: GetProvidersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersSuspense<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
 params?: GetProvidersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProvidersSuspense<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
 params?: GetProvidersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProviderConfigsUrl = () => {




  return `/api/Sso/GetProviderConfigs`
}

export const getProviderConfigs = async ( options?: Parameters<typeof customInstance>[1]): Promise<ProviderDto[]> => {

  return customInstance<ProviderDto[]>(getGetProviderConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProviderConfigsQueryKey = () => {
    return [
    `/api/Sso/GetProviderConfigs`
    ] as const;
    }


export const getGetProviderConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProviderConfigsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProviderConfigs>>> = ({ signal }) => getProviderConfigs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProviderConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getProviderConfigs>>>
export type GetProviderConfigsQueryError = ErrorType<unknown>


export function useGetProviderConfigs<TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderConfigs>>,
          TError,
          Awaited<ReturnType<typeof getProviderConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProviderConfigs<TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderConfigs>>,
          TError,
          Awaited<ReturnType<typeof getProviderConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProviderConfigs<TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProviderConfigs<TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProviderConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProviderConfigsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProviderConfigsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProviderConfigs>>> = ({ signal }) => getProviderConfigs({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProviderConfigsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProviderConfigs>>>
export type GetProviderConfigsSuspenseQueryError = ErrorType<unknown>


export function useGetProviderConfigsSuspense<TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProviderConfigsSuspense<TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProviderConfigsSuspense<TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProviderConfigsSuspense<TData = Awaited<ReturnType<typeof getProviderConfigs>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProviderConfigsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSsoLoginUrl = (configId: number,
    params?: SsoLoginParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Sso/login/${configId}?${stringifiedParams}` : `/api/Sso/login/${configId}`
}

export const ssoLogin = async (configId: number,
    params?: SsoLoginParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getSsoLoginUrl(configId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSsoLoginQueryKey = (configId: number,
    params?: SsoLoginParams,) => {
    return [
    `/api/Sso/login/${configId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getSsoLoginQueryOptions = <TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(configId: number,
    params?: SsoLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSsoLoginQueryKey(configId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ssoLogin>>> = ({ signal }) => ssoLogin(configId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: configId !== null && configId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SsoLoginQueryResult = NonNullable<Awaited<ReturnType<typeof ssoLogin>>>
export type SsoLoginQueryError = ErrorType<unknown>


export function useSsoLogin<TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(
 configId: number,
    params: undefined |  SsoLoginParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ssoLogin>>,
          TError,
          Awaited<ReturnType<typeof ssoLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSsoLogin<TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(
 configId: number,
    params?: SsoLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ssoLogin>>,
          TError,
          Awaited<ReturnType<typeof ssoLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSsoLogin<TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(
 configId: number,
    params?: SsoLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSsoLogin<TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(
 configId: number,
    params?: SsoLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSsoLoginQueryOptions(configId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSsoLoginSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(configId: number,
    params?: SsoLoginParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSsoLoginQueryKey(configId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ssoLogin>>> = ({ signal }) => ssoLogin(configId,params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type SsoLoginSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ssoLogin>>>
export type SsoLoginSuspenseQueryError = ErrorType<unknown>


export function useSsoLoginSuspense<TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(
 configId: number,
    params: undefined |  SsoLoginParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSsoLoginSuspense<TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(
 configId: number,
    params?: SsoLoginParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSsoLoginSuspense<TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(
 configId: number,
    params?: SsoLoginParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSsoLoginSuspense<TData = Awaited<ReturnType<typeof ssoLogin>>, TError = ErrorType<unknown>>(
 configId: number,
    params?: SsoLoginParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ssoLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSsoLoginSuspenseQueryOptions(configId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateProviderUrl = () => {




  return `/api/Sso/CreateProvider`
}

export const createProvider = async (createProviderDto?: CreateProviderDto, options?: Parameters<typeof customInstance>[1]): Promise<ProviderDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ProviderDto>(getCreateProviderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createProviderDto)
  }
);}





export const getCreateProviderMutationKey = () => ['createProvider'] as const;

export const getCreateProviderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvider>>, TError,CreateProviderMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProvider>>, TError,CreateProviderMutationVariables, TContext> => {

const mutationKey = getCreateProviderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProvider>>, CreateProviderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createProvider(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProviderMutationResult = NonNullable<Awaited<ReturnType<typeof createProvider>>>
    export type CreateProviderMutationBody = BodyType<CreateProviderDto> | undefined
    export type CreateProviderMutationError = ErrorType<unknown>
    export type CreateProviderMutationVariables = {data?: BodyType<CreateProviderDto>}

    export const useCreateProvider = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvider>>, TError,CreateProviderMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProvider>>,
        TError,
        CreateProviderMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProviderMutationOptions(options), queryClient);
    }
    export const getUpdateProviderUrl = (configId: number,) => {




  return `/api/Sso/provider/${configId}`
}

export const updateProvider = async (configId: number,
    updateProviderDto?: UpdateProviderDto, options?: Parameters<typeof customInstance>[1]): Promise<ProviderDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ProviderDto>(getUpdateProviderUrl(configId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProviderDto)
  }
);}





export const getUpdateProviderMutationKey = () => ['updateProvider'] as const;

export const getUpdateProviderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProvider>>, TError,UpdateProviderMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProvider>>, TError,UpdateProviderMutationVariables, TContext> => {

const mutationKey = getUpdateProviderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProvider>>, UpdateProviderMutationVariables> = (props) => {
          const {configId,data} = props ?? {};

          return  updateProvider(configId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProviderMutationResult = NonNullable<Awaited<ReturnType<typeof updateProvider>>>
    export type UpdateProviderMutationBody = BodyType<UpdateProviderDto> | undefined
    export type UpdateProviderMutationError = ErrorType<unknown>
    export type UpdateProviderMutationVariables = {configId: number;data?: BodyType<UpdateProviderDto>}

    export const useUpdateProvider = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProvider>>, TError,UpdateProviderMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProvider>>,
        TError,
        UpdateProviderMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProviderMutationOptions(options), queryClient);
    }
    export const getDeleteProviderUrl = (configId: number,) => {




  return `/api/Sso/provider/${configId}`
}

export const deleteProvider = async (configId: number, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteProviderUrl(configId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProviderMutationKey = () => ['deleteProvider'] as const;

export const getDeleteProviderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvider>>, TError,DeleteProviderMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProvider>>, TError,DeleteProviderMutationVariables, TContext> => {

const mutationKey = getDeleteProviderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProvider>>, DeleteProviderMutationVariables> = (props) => {
          const {configId} = props ?? {};

          return  deleteProvider(configId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProviderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProvider>>>

    export type DeleteProviderMutationError = ErrorType<unknown>
    export type DeleteProviderMutationVariables = {configId: number}

    export const useDeleteProvider = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvider>>, TError,DeleteProviderMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProvider>>,
        TError,
        DeleteProviderMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProviderMutationOptions(options), queryClient);
    }
